import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { loading: false, data: [], error: "", message: "" }


export const getCategoryAction = createAsyncThunk(
    'get-category',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/categories?is_deleted=${data?.is_deleted || false}&s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getCategorySlice = createSlice({
    name: 'get-category',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getCategoryAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getCategoryAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.message = action?.payload?.message
            })
            builder.addCase(getCategoryAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.message = action?.payload?.message
            })
        },

})



export const getCategoryReducer = getCategorySlice.reducer    